import {
  WSAlert,
  WSAlertProps,
  WSList,
  WSListProps
} from "@wingspanhq/fe-component-library";

interface Props extends WSListProps {
  alerts: (WSAlertProps | undefined)[];
}

const alertPriorityOrder: WSAlertProps["theme"][] = [
  "error",
  "warning",
  "success",
  "info",
  "neutral"
];

export const Alerts: React.FC<Props> = ({ alerts, ...listProps }) => {
  const sortedAlerts = alerts.filter(Boolean).sort((a, b) => {
    const aIndex = alertPriorityOrder.indexOf(a?.theme || "neutral");
    const bIndex = alertPriorityOrder.indexOf(b?.theme || "neutral");
    return aIndex - bIndex;
  });

  return (
    <WSList gap="S" {...listProps}>
      {sortedAlerts.map((alert, index) => (
        <WSAlert key={`${alert?.title}-${index}`} {...alert} />
      ))}
    </WSList>
  );
};
